/* eslint-disable complexity */
import React, {useEffect, useState, useCallback} from "react";
import PropTypes from "prop-types";
// import loadable from "@loadable/component";
import styles from "./styles.css";
import LoanLoader from "./images/loan-loader.svg";
import useToggle from "../../../hooks/use-toggle";
import { BANK_NOC, LOAN_STATUS } from "./constant";
import PostInspectionDiyOfferDeductions from "../post-inspection-diy-offer-deductions";
import RequiredDocumentUpload from "../required-document-upload";
import { REQUIRED_DOCUMENTS_LIST } from "../post-inspection-diy/constant";
import { filterRequiredDocumentList } from "../post-inspection-diy-doc-upload/selector";
import PostInspectionDiyCibilContainer from "../post-inspection-diy-cibil-container";
import Modal from "../../shared/modal";
import priceFormatter from "../../../utils/helpers/price-formatter";
import Button from "../button";
import PostInspectionDiyLoanAmount from "../post-inspection-diy-loan-amount";
import PostInspectionDiyLoanBankNoc from "../post-inspection-diy-loan-bank-noc";
import PostInspectionDiyLoanStatus from "../post-inspection-diy-loan-status";
import { TAB_NAMES } from "../post-inspection-diy-header-v2/constant";
import { sendCustomGaEvents } from "../../../tracking";
import { diyLoanStatusInput } from "./tracking";

// eslint-disable-next-line max-statements
const PostInspectionDiyLoanDetails = ({
    inspectionResponse,
    diyPaymentApprovalProcessConnect = () => {},
    postTokenDocuments = {},
    loanDetails = {},
    submitLoanDetailsConnect = () => {},
    setActiveTabConnect = () => {}
}) => {

    const { documents = {} } = postTokenDocuments || {};
    const { consent = true,
        creditReportPhoneError = false,
        loanStatus = LOAN_STATUS.CLOSED,
        validNocAvailable,
        pendingLoanAmount,
        updateAllowed = true
    } = loanDetails || {};
    const { otherDocuments = {} } = documents || {};
    const requiredDocumentList = filterRequiredDocumentList(otherDocuments, REQUIRED_DOCUMENTS_LIST.LOAN_DOCUMENTS);
    const { LOAN_DOCUMENTS = {} } = requiredDocumentList || {};
    const {appointmentId = "", token = ""} = inspectionResponse || {};

    const [isLoading, setIsLoading] = useState(true);
    const [loanAmount, setLoanAmount] = useState(pendingLoanAmount);
    const [showCibilQuestions, setShowCibilQuestions] = useState(!consent || creditReportPhoneError);
    const [isOpenLoan, setIsOpenLoan] = useToggle(loanStatus === LOAN_STATUS.PENDING);
    const [selectedNoc, setSelectedNoc] = useState(validNocAvailable ? BANK_NOC.VALID_NOC : BANK_NOC.NO_VALID_NOC);
    const [secondaryDocDetails, setSecondaryDocDetails] = useState();

    const { documents: secondaryDocs = {} } = secondaryDocDetails || {};
    const { otherDocuments: secondaryOtherDocs = {}} = secondaryDocs || {};
    const requiredDocumentListSecondary = filterRequiredDocumentList(secondaryOtherDocs, REQUIRED_DOCUMENTS_LIST.LOAN_DOCUMENTS);

    const callSecondaryLoanDetails = () => {
        diyPaymentApprovalProcessConnect(token, LOAN_STATUS.CLOSED, false)
            .then((res) => {
                setSecondaryDocDetails(res);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    const callGaHandler = useCallback((details) => {
        sendCustomGaEvents({
            eventLabel: appointmentId,
            ...details
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        callSecondaryLoanDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelection = ({target}, type) => {
        const {value = ""} = target || {};
        if (type === "NOC") setSelectedNoc(value);
        else setLoanAmount(value);
    };

    const handleChange = () => {
        setIsOpenLoan();
        setIsLoading(false);
        callGaHandler(diyLoanStatusInput);
    };

    const handleDiyPaymentApprovalProcess = () => {
        diyPaymentApprovalProcessConnect(token, isOpenLoan ? LOAN_STATUS.PENDING : LOAN_STATUS.CLOSED, true);
    };

    if (isLoading) {
        return (
            <Modal isOpen={true}>
                <div styleName={"styles.loaderPopup"}>
                    <img src={LoanLoader} alt="loader" />
                    <h4>Please wait..</h4>
                    <p>We are checking your car loan details</p>
                </div>
            </Modal>
        );
    }

    if (showCibilQuestions) {
        return (
            <PostInspectionDiyCibilContainer
                loanDetails={loanDetails}
                setShowCibilQuestions={setShowCibilQuestions}
            />
        );
    }

    const disabilityCheck = () => !updateAllowed || (isOpenLoan  &&  loanAmount === "") || (!isOpenLoan && !selectedNoc);

    const handleSubmit = () => {
        const payload = {
            loanStatus: isOpenLoan ? LOAN_STATUS.PENDING : LOAN_STATUS.CLOSED,
            validNocAvailable: selectedNoc === BANK_NOC.VALID_NOC,
            pendingLoanAmount: loanAmount
        };
        submitLoanDetailsConnect(token, payload)
            .then(() => {
                setActiveTabConnect(TAB_NAMES.DOCUMENTATION);
            });
    };

    return (
        <div styleName={"styles.loanWrapper"}>
            <PostInspectionDiyLoanStatus
                isOpenLoan={isOpenLoan}
                updateAllowed={updateAllowed}
                handleChange={handleChange}
                callGaHandler={callGaHandler}
            />
            {isOpenLoan ?
                <PostInspectionDiyLoanAmount
                    handleSelection={handleSelection}
                    loanAmount={loanAmount}
                    updateAllowed={updateAllowed}
                /> :
                <PostInspectionDiyLoanBankNoc
                    handleSelection={handleSelection}
                    selectedNoc={selectedNoc}
                    updateAllowed={updateAllowed}
                />
            }
            <PostInspectionDiyOfferDeductions
                pendingLoanAmount={loanAmount}
                showBottomText={false} >
                {isOpenLoan &&
                    <div styleName={"styles.pendingAmountWrapper"}>
                        <p>Pending loan amount</p>
                        <span>₹{priceFormatter(loanAmount)}</span>
                    </div>
                }
            </PostInspectionDiyOfferDeductions>
            { LOAN_DOCUMENTS && !!LOAN_DOCUMENTS.length &&
                <div styleName={"styles.documentWrapper"}>
                    <RequiredDocumentUpload
                        uploadSource={"CUSTOMER"}
                        showDocumentProgress={false}
                        isDocUploadAllowed={true}
                        appointmentId={appointmentId}
                        allDocuments={isOpenLoan ? requiredDocumentList : requiredDocumentListSecondary}
                        handleDiyPaymentApprovalProcess={handleDiyPaymentApprovalProcess}
                        requiredDocumentType={REQUIRED_DOCUMENTS_LIST.LOAN_DOCUMENTS}
                        showRtoInfo={false}
                    />
                    <p styleName={"styles.loanDocLabel"}>Check with your bank for your vehicle loan related documents</p>
                </div>
            }
            <div styleName={"styles.cibilCtaWrapper" }>
                <Button
                    text={"SUBMIT"}
                    isLoading={isLoading}
                    disabled={disabilityCheck()}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

PostInspectionDiyLoanDetails.propTypes = {
    inspectionResponse: PropTypes.object,
    updateAllowed: PropTypes.bool,
    openLoan: PropTypes.bool,
    diyPaymentApprovalProcessConnect: PropTypes.func,
    postTokenDocuments: PropTypes.object,
    loanDetails: PropTypes.object,
    fetchLoanDetailsConnect: PropTypes.func,
    submitLoanDetailsConnect: PropTypes.func,
    setActiveTabConnect: PropTypes.func
};

export default PostInspectionDiyLoanDetails;
